import React from 'react';
import { Link } from 'gatsby';

import OptimizedImage from '../../OptimizedImage';

const Description = () => {
  return (
    <div className="main-beam">
      <div className="row">
        <div className="col-lg-5 col-mn-12">
          <div className="desc-section">
            <h2 className="subtitle bigger">
              We serve as <span>independent advisors </span> in the field of
              code audits
            </h2>
            <div className="content">
              <p>
                Ask us for assistance if you are an investor that runs due
                diligence, a third-party software supplier that needs to provide
                checked and proven code quality, or are in the process of
                recruiting an outsourcing company and want to verify the quality
                beforehand.
              </p>
            </div>
            <Link to="/how-we-work/" className="btn btn-main narrow">
              Check how we work
            </Link>
          </div>
        </div>
        <div className="col-lg-7 col-md-12">
          <div className="image-section">
            <OptimizedImage
              src="pages/code-audit-2.png"
              className="img-fluid"
              alt="code audit photography"
              title="Code audit"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Description;
